export default "__VITE_ASSET__Ci4qBjHH__"